module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab4/awsop-lab4.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab4/awsop-lab4.component.css
// module chunks = main